import { EntryModule } from "@/store/modules/entry.module";
import { ReportsModule } from "@/store/modules/report.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const entryListingMachineMachine = Machine({
    id: "entryListingMachine",
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "entries",
            },
        },
        entries: {
            type: "parallel",
            states: {
                operation: {
                    initial: "idle",
                    states: {
                        idle: {
                            on: {
                                GETTING_ENTRIES: { target: "gettingEntryDeatils", actions: "assignSearchData" },
                            },
                        },
                        gettingEntryDeatils: {
                            tags: "gettingEntries",
                            invoke: {
                                id: "gettingEntryDeatils",
                                src: (context, event) => {
                                    return EntryModule.GetEntriesPrerequisites();
                                },
                                onDone: { target: "gettingEntries", actions: "conditionallyAssignSearchData" },
                                onError: { target: "serviceUnavailable" },
                            },
                        },
                        gettingEntries: {
                            tags: "gettingEntries",
                            invoke: {
                                id: "gettingEntries",
                                src: (context, event) => {
                                    return EntryModule.GetEntries(context.searchData);
                                },
                                onDone: [
                                    {
                                        target: "errorState",
                                        cond: (context, event) => {
                                            return event.data.warningMessages[0];
                                        },
                                    },
                                    {
                                        target: "loadedEntries",
                                        actions: "clearPageChange",
                                    },
                                ],
                                onError: { target: "serviceUnavailable" },
                            },
                        },
                        errorState: {
                            tags: "errorUI",
                            on: {
                                GETTING_ENTRIES: { target: "gettingEntries", actions: "assignSearchData" },
                            },
                        },
                        loadedEntries: {
                            on: {
                                GETTING_ENTRIES: { target: "gettingEntries", actions: "assignSearchData" },
                                DELETE_ENTRIES: { target: "deleteEntries", actions: "assignLastpage" },
                                ARCHIVE_ENTRIES: { target: "archiveEntries" },
                                UN_ARCHIVE_ENTRIES: { target: "unArchiveEntries" },
                                FAVORITE_ENTRY: {
                                    target: "favoriteEntry",
                                },
                                FAVORITE_ENTRY_WITH_RELOAD: { target: "favoriteEntryWithReload" },
                                SHOW_SAVE_SEARCH: { target: "saveSearch" },
                                GETTING_SEARCHES: { target: "gettingSearches" },
                                EXPORTING_ENTRIES: { target: "exportingReport", actions: "assignReportName" },
                                REJECT_ENTRY: { target: "rejectEntry" },
                                APPROVING_ENTRY: { target: "approvingEntry" },
                            },
                        },
                        deleteEntries: {
                            tags: "showEntriesDelete",
                            on: {
                                DELETING_ENTRIES: { target: "deletingEntries", actions: "deletingEntriesCount" },
                                CANCEL: { target: "loadedEntries" },
                            },
                        },
                        deletingEntries: {
                            tags: "showEntriesDelete",
                            invoke: {
                                id: "deletingEntries",
                                src: (context, event) => {
                                    return EntryModule.DeleteEntries({ searchParams: event.searchParams, isAllSelected: event.isAllSelected, entries: event.entries });
                                },
                                onDone: { target: "gettingEntries", actions: ["showSuccessMessage", "setPage"] },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        archiveEntries: {
                            tags: "showEntriesArchive",
                            on: {
                                ARCHIVING_ENTRIES: { target: "archivingEntries" },
                                CANCEL: { target: "loadedEntries" },
                            },
                        },
                        archivingEntries: {
                            tags: "showEntriesArchive",
                            invoke: {
                                id: "archivingEntries",
                                src: (context, event) => {
                                    return EntryModule.ArchiveEntries({ searchParams: event.searchParams, isAllSelected: event.isAllSelected, entries: event.entries });
                                },
                                onDone: { target: "gettingEntries", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        unArchiveEntries: {
                            tags: "showEntriesUnArchive",
                            on: {
                                UN_ARCHIVING_ENTRIES: { target: "unArchivingEntries" },
                                CANCEL: { target: "loadedEntries" },
                            },
                        },
                        unArchivingEntries: {
                            tags: "showEntriesUnArchive",
                            invoke: {
                                id: "unArchivingEntries",
                                src: (context, event) => {
                                    return EntryModule.unArchiveEntries({ entries: event.entries });
                                },
                                onDone: { target: "gettingEntries", actions: "showUnArchiveEntryMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        favoriteEntry: {
                            invoke: {
                                id: "favoriteEntry",
                                src: (context, event) => {
                                    return EntryModule.AddToFavorities({ entryId: event.entryId, isFavorite: event.isFavorite });
                                },
                                onDone: { target: "loadedEntries", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        favoriteEntryWithReload: {
                            invoke: {
                                id: "favoriteEntryWithReload",
                                src: (context, event) => {
                                    return EntryModule.AddToFavorities({ entryId: event.entryId, isFavorite: event.isFavorite });
                                },
                                onDone: { target: "gettingEntries", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        saveSearch: {
                            tags: "showSaveSearch",
                            on: {
                                SAVING_SEARCH: { target: "savingSearch" },
                                CANCEL: { target: "loadedEntries" },
                            },
                        },
                        savingSearch: {
                            invoke: {
                                id: "savingSearch",
                                src: (context, event) => {
                                    return EntryModule.SaveSearch(event.entrySaveSearch);
                                },
                                onDone: { target: "loadedEntries", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        gettingSearches: {
                            invoke: {
                                id: "gettingSearches",
                                src: (context, event) => {
                                    return EntryModule.GetSaveSearch();
                                },
                                onDone: { target: "loadedSearches" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        loadedSearches: {
                            tags: "showSearchesUI",
                            on: {
                                DELETING_SEARCH: { target: "deletingSearch" },
                                CANCEL: { target: "loadedEntries" },
                                APPLY_SEARCH: { target: "loadedEntries" },
                                SHARE_SEARCH: { target: "sharingSearch" },
                            },
                        },
                        deletingSearch: {
                            tags: "showSearchesUI",
                            invoke: {
                                id: "savingSearch",
                                src: (context, event) => {
                                    return EntryModule.DeleteSearchById(event.searchId);
                                },
                                onDone: { target: "loadedSearches", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        sharingSearch: {
                            tags: "showSearchesUI",
                            invoke: {
                                id: "sharingSearch",
                                src: (context, event) => {
                                    return EntryModule.ShareSearch({ searchId: event.searchId, isSharable: event.isSharable });
                                },
                                onDone: { target: "loadedSearches", actions: "showSuccessMessage" },
                                onError: { target: "loadedEntries" },
                            },
                        },
                        exportingReport: {
                            tags: "exportingReport",
                            invoke: {
                                id: "exportingReport",
                                src: (context, event) => {
                                    return ReportsModule.ExportReport(event.entryReport);
                                },
                                onDone: { target: "loadedEntries", actions: "downloadReports" },
                                onError: { target: "serviceUnavailable" },
                            },
                        },
                        rejectEntry: {
                            tags: "rejectUI",
                            on: {
                                REJECTING_ENTRY: { target: "rejectingEntry" },
                                CANCEL: { target: "loadedEntries" },
                            },
                        },
                        rejectingEntry: {
                            tags: "rejectUI",
                            invoke: {
                                id: "rejectingEntry",
                                src: (context, event) => {
                                    return EntryModule.RejectEntry(event.rejectedReason);
                                },
                                onDone: { target: "gettingEntries", actions: "showSuccessMessage" },
                                onError: { target: "serviceUnavailable" },
                            },
                        },
                        approvingEntry: {
                            tags: "approveState",
                            invoke: {
                                id: "approvingEntry",
                                src: (context, event) => {
                                    return EntryModule.ApproveEntry(event.entryId);
                                },
                                onDone: { target: "gettingEntries", actions: "showSuccessMessage" },
                                onError: { target: "serviceUnavailable" },
                            },
                        },
                        serviceUnavailable: {},
                    },
                },
                selection: {
                    initial: "idle",
                    states: {
                        idle: {
                            on: {
                                BASIC_SELECTION: { target: "basic" },
                                BULK_SELECTION: { target: "pageSelected" },
                            },
                        },
                        basic: {
                            tags: ["showMutilSelectButton"],
                            on: {
                                BULK_SELECTION: { target: "pageSelected" },
                                CANCEL_SELECTION: { target: "idle" },
                            },
                        },
                        pageSelected: {
                            tags: ["selection", "showMutilSelectButton"],
                            on: {
                                BULK_CONFIRMED: { target: "bulkSelected" },
                                CANCEL_SELECTION: { target: "idle" },
                                BASIC_SELECTION: { target: "basic" },
                            },
                        },
                        bulkSelected: {
                            tags: ["showMutilSelectButton", "bulkSelected"],
                            on: {
                                BULK_SELECTION: { target: "pageSelected" },
                                CANCEL_SELECTION: { target: "idle" },
                            },
                        },
                    },
                },
                search: {
                    initial: "idle",
                    states: {
                        idle: {
                            always: { target: "basicSearch" },
                        },
                        basicSearch: {
                            tags: "basicSearch",
                            on: {
                                ADVANCE_SEARCH: { target: "advanceSearch" },
                                SHOW_ADVANCE_SEARCH_FLAP: { target: "showAdvanceSearchFlap" },
                            },
                        },
                        showAdvanceSearchFlap: {
                            tags: "showAdvanceSearchFlap",
                            on: {
                                ADVANCE_SEARCH: { target: "advanceSearch" },
                                BASIC_SEARCH: { target: "basicSearch" },
                            },
                        },
                        advanceSearch: {
                            tags: "advanceSearch",
                            on: {
                                BASIC_SEARCH: { target: "basicSearch" },
                                SHOW_ADVANCE_SEARCH_FLAP: { target: "showAdvanceSearchFlap" },
                            },
                        },
                    },
                },
            },
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => {
                return event.searchData;
            },
        }),
        assignLastpage: assign({
            isPageChanged: (context, event) => {
                return event.isPageChanged;
            },
        }),
        deletingEntriesCount: assign({
            entriesCount: (context, event) => {
                if (event.isAllSelected) {
                    return EntryModule.totalCount;
                }
                else {
                    return event.entries.length;
                }
            },
        }),
        showUnArchiveEntryMessage: () => {
            toaster.ShowSuccess("The entry  has been unarchived successfully.");
        },
        downloadReports: (context, event) => {
            const blob = new Blob([event.data], {
                type: "application/msword",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = `${context.reportName}.docx`;
            link.click();
            document.body.removeChild(link);
        },
        assignReportName: assign({
            reportName: (context, event) => event.reportName,
        }),
        clearPageChange: assign({
            isPageChanged: (context, event) => false,
            entriesCount: (context, event) => 0,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.isPageChanged && context.entriesCount === event.data.entriesCount && context.entriesCount == EntryModule.entries.length && context.searchData.page != 1) {
                    const updatedSearchData = {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                    EntryModule.AssignParams(updatedSearchData);
                    return updatedSearchData;
                }
                return context.searchData;
            },
        }),
        conditionallyAssignSearchData: assign((context, event) => {
            if (EntryModule.saveSearch != null) {
                return {
                    searchData: EntryModule.saveSearch.entrySearch,
                };
            }
            return {};
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default entryListingMachineMachine;
